import React from 'react'


const Privacy: React.FC = () => {
  return (
    <div className="Privacy">
      <p>SLog is a Simple Weblog.</p>
      <p>If you don't log in, we don't have any of your data.</p>
      <p>If you comment on a post, your email address will be collected and attached to your comment, and will only be visible to the owner of the Blog</p>
      <p>If you elect to have your data deleted, you profile will be deactivated. Note that comments will remain.</p>
    </div>
  )
}

export default Privacy